var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-not-found-popup"},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.pds)+" :")]),_vm._v(" "+_vm._s(this.$i18n.t('_account_not_found')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }